const pagesIndividualOperationPackageEn = {
  navigateToHome: 'Home',
  navigateToSelectPattern: 'Select pattern',
  navigateToSelectTarget: 'Select software',
  page: {
    selectPattern: {
      description: 'Select a pattern'
    },
    startOperationPackage: {
      goToHome: 'Go to Home',
      processStartedMessage: '{{operationPackageName}} process started!',
      requestFor: 'Request For',
      startOperationPackage: 'Start {{operationPackageName}}'
    }
  }
};
export default pagesIndividualOperationPackageEn;